import Image, { type ImageProps } from '2-core-elements/Image/Image';


export type PeopleCardProps = {
    img?: Pick<ImageProps, 'imgSrc' | 'imgAlt' | 'imgHeight' | 'imgWidth' | 'imgSrcSet'>;
    title: string;
};

const GiftTile = ({ img, title }: PeopleCardProps): JSX.Element => {
    return (
        <div className="gift-tile">
            {
                img?.imgSrc && <Image aspectRatio="16/9" imgSrc={img.imgSrc} imgAlt={img.imgAlt} imgSrcSet={img.imgSrcSet} />
            }
            {title && (
                <div className="gift-tile-title-wrapper">
                    <h2 className="gift-tile-title">{title}</h2>
                </div>
            )}
        </div>
    );
};

export default GiftTile;
